<template>
  <Content :button-create-show="true">
    <template #body>
      <Table
        :columns="columns"
        :options="columnsOptions"
        :method-fetch-data="methods.fetchData"
        :method-delete-row="methods.deleteRow"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Table from "@/components/Table";

import { getAdmins as fetchData } from "@/api/admins";

const columnsOptions = {
  sortable: "custom",
  controls: true,
  id: "id",
  edit: true,
};

const columns = [
  {
    prop: "id",
    label: "ID",
    width: 300,
  },
  {
    prop: "login",
    label: "Псевдоним",
  },
  {
    prop: "role",
    label: "Роль",
    type: "enum",
    alias: "role_type",
  },
  {
    prop: "city",
    label: "Регион",
    type: "enum",
    alias: "region",
  },
];

export default {
  components: {
    Content,
    Table,
  },
  data() {
    return {
      columnsOptions: columnsOptions,
      columns: columns,
      methods: {
        fetchData,
      },
    };
  },
};
</script>
